import { hFetch } from '@/lib/hfetch';
import type { PipelineReviewEntity, PipelineReviewLateness } from '@/api/entity_types/PipelineReview';
import type { PipelineReviewQuestionEntity } from '@/api/entity_types/pipeline_review/Question';
import type { PipelineReviewAnswerEntity } from '@/api/entity_types/pipeline_review/Answer';

export type AgentPipelineReviewQuestionWithAnswer = {
  question: PipelineReviewQuestionEntity;
  answer: PipelineReviewAnswerEntity | null;
};

export type AgentPipelineReviewResponse = {
  pipeline_review: (PipelineReviewEntity & { lateness: PipelineReviewLateness }) | null;
  questions_with_answers: AgentPipelineReviewQuestionWithAnswer[];
};

export const getCurrentPipelineReview = async () => {
  return await hFetch<AgentPipelineReviewResponse>({
    url: `/api/agent/pipeline_review`,
  });
};

export type UpsertAnswerEntry = {
  question_id: number;
  answer: string;
};

export const upsertAnswers = async (answers: UpsertAnswerEntry[]) => {
  return await hFetch<unknown, { answers: UpsertAnswerEntry[] }>({
    url: `/api/agent/pipeline_review`,
    method: 'PATCH',
    payload: { answers },
  });
};
